import { GetLocationModel } from "@factory/model/query-model-location";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { locationFormDefault } from "./form.default";
import { LocationFormSchema } from "./form.rule";

export const useFormDefaultLocation = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetLocationModel | undefined) => {
    return !cachedValue
      ? locationFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as LocationFormSchema);
  };

  return {
    getDefault,
  };
};
